import './control.style.scss'
import IPlayer from '../../core/IPlayer'
import IOption from '../../core/PlayerOptions'
import { PlayerStatus } from '../../common/enums'
import PlayerConfig from '../../core/PlayerConfig'

export class InitOption implements IOption {
  width?: string = '100%'
  height?: string = '100%'
  id = ''
  playerConfig: PlayerConfig = new PlayerConfig()
}

const convertTime = function(time = 0): string {
  const hour = Math.floor(time / 3600)
  const minutes = Math.floor((time - hour * 3600) / 60)
  const second = Math.floor(time - (hour * 3600 + minutes * 60))
  return `${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${second
    .toString()
    .padStart(2, '0')}`
}

class Control extends IPlayer {
  currentTime = 0
  className = 'player-document-control'
  options: InitOption = new InitOption()
  playTimer: number

  constructor(options: InitOption) {
    super()
    this.options = Object.assign(this.options, options)
    this.options = options
    this.currentTime = this.options.playerConfig.currentTime
    this.createEl()
  }

  elContainer: HTMLElement
  elCurrentTime: HTMLElement
  elDuration: HTMLElement
  elProgress: HTMLElement

  createEl() {
    const playerBox = document.querySelector(`#${this.options.id}`) as HTMLElement
    this.elContainer = document.createElement('div')
    this.elCurrentTime = document.createElement('div')
    this.elCurrentTime.setAttribute('class', 'tool _left')
    const progressContainer = document.createElement('div')
    this.elProgress = document.createElement('div')
    progressContainer.setAttribute('class', 'tool _progress-container')
    this.elProgress.setAttribute('class', 'tool _progress')
    this.elDuration = document.createElement('div')
    this.elDuration.setAttribute('class', 'tool _right')
    this.elCurrentTime.innerHTML = '00:00:00'
    this.elContainer.appendChild(this.elCurrentTime)
    progressContainer.appendChild(this.elProgress)
    this.elContainer.appendChild(progressContainer)
    this.elDuration.innerHTML = '00:00:00'
    this.elContainer.appendChild(this.elDuration)
    this.elContainer.setAttribute('class', this.className)
    if (playerBox) {
      playerBox.appendChild(this.elContainer)
    }

    playerBox.addEventListener('mouseenter', () => {
      this.elContainer.style.bottom = '5px'
    })

    playerBox.addEventListener('mouseleave', () => {
      this.hide(0)
    })

    this.hide(1500)
    this.setDuration(this.options.playerConfig.duration)
    this.play()
  }

  private hide(timeout: number) {
    setTimeout(() => {
      this.elContainer.style.bottom = '-40px'
    }, timeout)
  }

  private setDuration(time?: number) {
    this.elDuration.innerHTML = convertTime(time)
  }

  getDuration() {
    return this.options.playerConfig.duration || 0
  }

  private setCurrentTime(time: number) {
    this.elCurrentTime.innerHTML = convertTime(time)
  }

  destroy(): boolean {
    this.emit(PlayerStatus.destroyed, this)
    this.stop()
    this.elContainer.remove()
    return false
  }

  getTime(): number {
    return this.currentTime
  }

  muted(mute: boolean): boolean {
    return mute
  }

  stop(): void {
    this.pause()
    this.emit(PlayerStatus.stop, this)
  }

  pause(): void {
    window.clearInterval(this.playTimer)
    this.playTimer = 0
    this.emit(PlayerStatus.paused, this)
  }

  play(): void {
    // 启动定时器

    this.pause()

    this.playTimer = setInterval(() => {
      if (this.currentTime + 1 >= this.getDuration()) {
        // 发送播放结束的事件
        this.emit(PlayerStatus.end)
        this.setTime(this.currentTime)
        return this.stop()
      }
      this.currentTime++
      this.setTime(this.currentTime)
      // 发送播放事件
      this.emit(PlayerStatus.playing, this.getTime())
    }, 1000)
  }

  setTime(time: number) {
    this.elCurrentTime.innerHTML = convertTime(time)
    if (!this.getDuration()) {
      this.elProgress.style.width = '100%'
    } else {
      this.elProgress.style.width = `${(this.getTime() / this.getDuration()) * 100}%`
    }
  }
}

export default Control
